import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { LINK_PRIVACY_POLICY } from 'shared/constants/links'
import { InputCheckbox, Typography } from 'shared/ui'
import { useLastPathSegment } from 'shared/hooks'
import { PageDescription } from 'pages/settings/ui/PageDescription/PageDescription'
import { useInternationalStepsContext } from 'pages/settings/pages/compliance/pages/international/context/internationalStepsContext'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { ErrorBanner } from 'pages/settings/pages/compliance/pages/international/ui/ErrorBanner/ErrorBanner'
import { type InternationalRoutes } from 'pages/settings/pages/compliance/pages/international'
import styles from './styles.module.scss'

export const FinalDetails = observer(() => {
  const {
    stepsStore: { stepLoading },
    submitForReview,
    toggleIsTermsAndPrivacyChecked,
    isTermsAndPrivacyChecked,
    initializeStepsForRoute,
  } = useInternationalStepsContext()
  const lastPathSegment = useLastPathSegment()

  useEffect(() => {
    initializeStepsForRoute(lastPathSegment as InternationalRoutes)
  }, [initializeStepsForRoute, lastPathSegment])

  return (
    <div>
      <PageDescription>
        Salesmsg will process your personal data according to the{' '}
        <a href={LINK_PRIVACY_POLICY} target='_blank' rel='noreferrer' className={styles.link}>
          <Typography
            ariaLabel='TermsAndPrivacy_link'
            variant='body-md-regular'
            color='var(--content-brand-primary)'
          >
            {'Salesmsg Privacy Policy'}
          </Typography>
        </a>
      </PageDescription>

      <ErrorBanner />

      <InputCheckbox
        className={styles.declaration}
        checked={isTermsAndPrivacyChecked}
        onChecked={toggleIsTermsAndPrivacyChecked}
        color='var(--content-primary-tertiary)'
        label='I declare that the information provided is accurate. I acknowledge that Salesmsg will be processing the information provided for the purposes of identity verification, and that telecommunications service providers and registries reserve the right to retain the Business Profile information after account closure in the case of a traceback from a regulatory authority or equivalent.'
      />

      <NextButton
        loading={stepLoading}
        disabled={!isTermsAndPrivacyChecked || stepLoading}
        text='Submit for review'
        onClick={submitForReview}
      />
    </div>
  )
})
